import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export type ProductItem = {
  id: string;
  name: string;
  size: string;
  unit: string;
  price: number;
};

export const defaultProductItem: ProductItem = {
    id: "",
    name: "",
    size: "",
    unit: "",
    price: 0
}

const productItemResolverSchema: Yup.ObjectSchema<ProductItem> = Yup.object({
    id: Yup.string().uuid().default("").required(),
    name: Yup.string().default("").required(),
    size: Yup.string().default("").optional(),
    unit: Yup.string().default("").optional(),
    price: Yup.number().default(0).optional()
}).required();

export const productItemFields = [
  { label: "제품명", name: "name", type: "text", required: true, multiline: false },
  { label: "규격", name: "size", type: "text", required: true, multiline: false },
  { label: "단위", name: "unit", type: "text", required: false, multiline: false },
  { label: "가격", name: "price", type: "number", required: false, multiline: false },
] as const;


export const productItemResolver = yupResolver(productItemResolverSchema);